module.exports = __webpack_public_path__ + "88c0c0580329f9284c337788113d322e.svg";